export const TIMEOUT_NOTIFICATION = 5000 // 5 secs for a default notification
export const TIMEOUT_NOTIFICATION_WITH_LINK = 10000 // 10 secs for a notification with a link click action
